import React from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';

import ConfirmEmailField from '../ConfirmEmailField';
import FormSubmitButton from '../FormSubmitButton';
import EmailField from '../EmailField';
import StaticEmailField from '../StaticEmailField';

import SignUpFields from '../SignUpFields';

import { formValidate } from '@eb/eds-utils';
import {
    newSignupValidate as validate,
    submitAsyncValidateConfirmEmail as asyncValidate,
} from '../utils';

import { SIGN_UP_FORM } from '../../constants';

class SignupForm extends React.Component {
    static propTypes = {
        handleEmailEdit: PropTypes.func,
        handleSubmit: PropTypes.func.isRequired,
        buttonCTA: translationPropType,
        email: PropTypes.string,
        locale: PropTypes.string,
        recaptcha2PublicKey: PropTypes.string,
        showCaptcha: PropTypes.bool,
        fp: PropTypes.bool,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
        socialSSOSettings: PropTypes.shape({
            facebook: PropTypes.object,
        }),
        trackEmailConfirmationEdit: PropTypes.func,
        trackEmailMismatchShowed: PropTypes.func,

        /* Props Provided Via ReduxForm */
        submitFailed: PropTypes.bool,
        submitSucceeded: PropTypes.bool,
        submitting: PropTypes.bool,
    };

    componentWillReceiveProps({ submitting, submitFailed, error }) {
        const { showNotification, clearNotification } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }
    }

    componentWillUnmount() {
        const { clearNotification } = this.props;

        clearNotification();
    }

    render() {
        const {
            formErrors,
            handleSubmit,
            email,
            buttonCTA,
            submitting,
            submitSucceeded,
            locale,
            recaptcha2PublicKey,
            showCaptcha,
            fp,
            clearNotification,
            submitFailed,
            socialSSOSettings,
            trackEmailMismatchShowed,
            handleEmailEdit,
        } = this.props;

        const submitDisabled = submitting;

        let emailField = (
            <EmailField
                isStatic={true}
                formErrors={formErrors}
                onEmailMismatch={trackEmailMismatchShowed}
                autoFocus={true}
            />
        );

        //To mantain functionality with actual flow
        if (email) {
            emailField = (
                <StaticEmailField
                    email={email}
                    formErrors={formErrors}
                    onEmailEdit={handleEmailEdit}
                    onEmailMismatch={trackEmailMismatchShowed}
                    clearNotification={clearNotification}
                    shouldRevealEmail={true}
                />
            );
        }

        return (
            <div className="eds-fx--fade-in eds-fx--delay-2">
                <form onSubmit={handleSubmit} noValidate="novalidate">
                    {emailField}

                    <ConfirmEmailField
                        email={email}
                        clearNotification={clearNotification}
                        submitFailed={submitFailed}
                        autoFocus={true}
                    />

                    <SignUpFields
                        locale={locale}
                        recaptcha2PublicKey={recaptcha2PublicKey}
                        showCaptcha={showCaptcha}
                        fp={fp}
                        submitFailed={submitFailed}
                        socialSSOSettings={socialSSOSettings}
                    />
                    <FormSubmitButton
                        submitDisabled={submitDisabled}
                        buttonClasses="eds-fx--fade-in-down eds-fx--delay-1 eds-l-mar-top-8"
                        buttonCTA={buttonCTA}
                    />
                </form>
            </div>
        );
    }
}

export default formValidate({
    validate,
    asyncValidate,
    form: SIGN_UP_FORM,
    touchOnBlur: true,
    touchOnChange: false,
})(SignupForm);
